import ko from "knockout";
import Holiday from "./admin-company-onboarding-holiday";
import { CustomError, customFetch as fetch } from "../../../fetch";

export default class CompanyLocation {
    parent: any;
    saving: KnockoutObservable<boolean>;
    validationErrors: KnockoutObservableArray<CustomError>;
    shouldDisableFields: KnockoutObservable<boolean>;
    
    name: KnockoutObservable<string>;
    address: KnockoutObservable<string>;
    branchCity: KnockoutObservable<string>;
    kvkNumber: KnockoutObservable<string>;
    fullTimeHours: KnockoutObservable<string>;
    otherCAO: KnockoutObservable<string>;
    pensionType: KnockoutObservable<string>;
    permanentEmployeesCount: KnockoutObservable<string>;
    temporaryEmployeesCount: KnockoutObservable<string>;
    
    hasOtherCAO: KnockoutObservable<boolean>;
    hasCateringCAO: KnockoutObservable<boolean>;
    hasOwnConditions: KnockoutObservable<boolean>;
    hasTravelAllowanceForPermanentEmployees: KnockoutObservable<boolean>;
    directVacationPayForTemporaryEmployees: KnockoutObservable<boolean>;
    holidayBonusPayout: KnockoutObservable<boolean>;
    
    vacationDays: KnockoutObservable<string>;
    legalVacationDays: KnockoutObservable<string>;
    extraVacationDays: KnockoutObservable<string>;
    vacationPayPercentage: KnockoutObservable<string>;
    advDaysCount: KnockoutObservable<string>;
    bonusPayType: KnockoutObservable<string>;
    otherSurcharges: KnockoutObservable<string>;
    pension: KnockoutObservable<string>;
    
    travelAllowanceFixedAmount: KnockoutObservable<string>;
    travelAllowancePerDay: KnockoutObservable<string>;
    holidayPlanning: KnockoutObservable<string>;
    hoursReporting: KnockoutObservable<string>;
    
    publicHolidays: KnockoutObservableArray<Holiday>;

    addNewAgreement: KnockoutObservable<boolean>;
    hideNewAgreement: KnockoutObservable<boolean>;

    documentName: KnockoutObservable<string>;
    document: KnockoutObservable<any>;
    signatureRequired: KnockoutObservable<boolean>;
    savingAgreement: KnockoutObservable<boolean>;
    loading: KnockoutObservable<boolean>;

    constructor(locationData?: any, parent?: any) {
        if(parent) {
            this.parent = parent;
            this.shouldDisableFields = ko.pureComputed(() => this.parent.onboardingStatus() !== 1);
        } else {
            this.shouldDisableFields = ko.observable<boolean>(false);
        }

        this.saving = ko.observable<boolean>(false);
        this.validationErrors = ko.observableArray<CustomError>();

        this.name = ko.observable(locationData?.name || "").extend({
            errorHandler: { source: this.validationErrors, id: 'Name' }
        });
        this.address = ko.observable(locationData?.address || "").extend({
            errorHandler: { source: this.validationErrors, id: 'Address' }
        });
        this.branchCity = ko.observable(locationData?.branch_city || "").extend({
            errorHandler: { source: this.validationErrors, id: 'BranchCity' }
        });
        this.kvkNumber = ko.observable(locationData?.kvk_number || "").extend({
            errorHandler: { source: this.validationErrors, id: 'KvkNumber' }
        });
        this.fullTimeHours = ko.observable(locationData?.full_time_hours || "").extend({
            errorHandler: { source: this.validationErrors, id: 'FullTimeHours' }
        });
        this.otherCAO = ko.observable(locationData?.other_cao || "").extend({
            errorHandler: { source: this.validationErrors, id: 'OtherCAO' }
        });
        this.pensionType = ko.observable(locationData?.pension_type || "").extend({
            errorHandler: { source: this.validationErrors, id: 'PensionType' }
        });
        this.permanentEmployeesCount = ko.observable(locationData?.permanent_employees_count || "").extend({
            errorHandler: { source: this.validationErrors, id: 'PermanentEmployeesCount' }
        });
        this.temporaryEmployeesCount = ko.observable(locationData?.temporary_employees_count || "").extend({
            errorHandler: { source: this.validationErrors, id: 'TemporaryEmployeesCount' }
        });

        this.hasOtherCAO = ko.observable<boolean>(locationData?.has_other_cao || false).extend({
            errorHandler: { source: this.validationErrors, id: 'HasOtherCAO' }
        });
        this.hasCateringCAO = ko.observable<boolean>(locationData?.has_catering_cao || false).extend({
            errorHandler: { source: this.validationErrors, id: 'HasCateringCAO' }
        });
        this.hasOwnConditions = ko.observable<boolean>(locationData?.has_own_conditions || false).extend({
            errorHandler: { source: this.validationErrors, id: 'HasOwnConditions' }
        });
        this.hasTravelAllowanceForPermanentEmployees = ko.observable<boolean>(locationData?.has_travel_allowance_for_permanent_employees || false).extend({
            errorHandler: { source: this.validationErrors, id: 'HasTravelAllowanceForPermanentEmployees' }
        });
        this.directVacationPayForTemporaryEmployees = ko.observable<boolean>(locationData?.direct_vacation_pay_for_temporary_employees || false).extend({
            errorHandler: { source: this.validationErrors, id: 'DirectVacationPayForTemporaryEmployees' }
        });
        this.holidayBonusPayout = ko.observable<boolean>(locationData?.holiday_bonus_payout || false).extend({
            errorHandler: { source: this.validationErrors, id: 'HolidayBonusPayout' }
        });
        
        this.vacationDays = ko.observable(locationData?.vacation_days || "").extend({
            errorHandler: { source: this.validationErrors, id: 'VacationDays' }
        });
        this.legalVacationDays = ko.observable(locationData?.legal_vacation_days || "").extend({
            errorHandler: { source: this.validationErrors, id: 'LegalVacationDays' }
        });
        this.extraVacationDays = ko.observable(locationData?.extra_vacation_days || "").extend({
            errorHandler: { source: this.validationErrors, id: 'ExtraVacationDays' }
        });
        this.vacationPayPercentage = ko.observable(locationData?.vacation_pay_percentage || "").extend({
            errorHandler: { source: this.validationErrors, id: 'VacationPayPercentage' }
        });
        this.advDaysCount = ko.observable(locationData?.adv_days_count || "").extend({
            errorHandler: { source: this.validationErrors, id: 'AdvDaysCount' }
        });
        this.bonusPayType = ko.observable(locationData?.bonus_pay_type || "").extend({
            errorHandler: { source: this.validationErrors, id: 'BonusPayType' }
        });
        this.otherSurcharges = ko.observable(locationData?.other_surcharges || "").extend({
            errorHandler: { source: this.validationErrors, id: 'OtherSurcharges' }
        });
        this.pension = ko.observable(locationData?.pension || "").extend({
            errorHandler: { source: this.validationErrors, id: 'Pension' }
        });
        
        this.travelAllowanceFixedAmount = ko.observable(locationData?.travel_allowance_fixed_amount || "").extend({
            errorHandler: { source: this.validationErrors, id: 'TravelAllowanceFixedAmount' }
        });
        this.travelAllowancePerDay = ko.observable(locationData?.travel_allowance_per_day || "").extend({
            errorHandler: { source: this.validationErrors, id: 'TravelAllowancePerDay' }
        });
        this.holidayPlanning = ko.observable(locationData?.holiday_planning || "").extend({
            errorHandler: { source: this.validationErrors, id: 'HolidayPlanning' }
        });
        this.hoursReporting = ko.observable(locationData?.hours_reporting || "").extend({
            errorHandler: { source: this.validationErrors, id: 'HoursReporting' }
        });
        
        this.addNewAgreement = ko.observable<boolean>(false);
        this.hideNewAgreement = ko.observable<boolean>(false);


        this.documentName = ko.observable<string>('')
            .extend({
                errorHandler: { source: this.validationErrors, id: 'FileName' }
            });

        this.document = ko.observable<any>()
            .extend({
                errorHandler: { source: this.validationErrors, id: 'File' }
            });
        this.signatureRequired = ko.observable<boolean>(false);
        this.savingAgreement = ko.observable<boolean>(false);

        const DEFAULT_HOLIDAY_NAMES = [
            "Nieuwjaarsdag",
            "Eerste en tweede paasdag",
            "Koningsdag",
            "Hemelvaartsdag",
            "Eerste pinksterdag",
            "Tweede pinksterdag",
            "Eerste en tweede kerstdag"
        ];
        
        const holidayMap = new Map<string, Holiday>();

        (locationData?.public_holidays || []).forEach((h: any) => {
            if (h.bonus_50 || h.time_for_time) {
                const holiday = new Holiday(h.name);
                holiday.bonus50(h.bonus_50 || false);
                holiday.timeForTime(h.time_for_time || false);
                holidayMap.set(h.name, holiday);
            }
        });
        
        DEFAULT_HOLIDAY_NAMES.forEach(name => {
            if (!holidayMap.has(name)) {
                holidayMap.set(name, new Holiday(name));
            }
        });
        
        this.publicHolidays = ko.observableArray(Array.from(holidayMap.values()));
        
        this.hasCateringCAO.subscribe((newValue) => {
            if (newValue) {
                this.hasOtherCAO(false);
                this.hasOwnConditions(false);
            }
        });

        this.hasOtherCAO.subscribe((newValue) => {
            if (newValue) {
                this.hasCateringCAO(false);
                this.hasOwnConditions(false);
            }
        });

        this.hasOwnConditions.subscribe((newValue) => {
            if (newValue) {
                this.hasCateringCAO(false);
                this.hasOtherCAO(false);
            }
        });
    }

    toJson() {
        return {
            name: this.name(),
            address: this.address(),
            branch_city: this.branchCity(),
            kvk_number: this.kvkNumber(),
            full_time_hours: this.fullTimeHours(),
            other_cao: this.otherCAO(),
            pension_type: this.pensionType(),
            has_catering_cao: this.hasCateringCAO(),
            has_other_cao: this.hasOtherCAO(),
            has_own_conditions: this.hasOwnConditions(),
            permanent_employees_count: this.permanentEmployeesCount(),
            temporary_employees_count: this.temporaryEmployeesCount(),
            has_travel_allowance_for_permanent_employees: this.hasTravelAllowanceForPermanentEmployees(),
            direct_vacation_pay_for_temporary_employees: this.directVacationPayForTemporaryEmployees(),
            standard_work_week: this.fullTimeHours(),
            vacation_days: this.vacationDays(),
            legal_vacation_days: this.legalVacationDays(),
            extra_vacation_days: this.extraVacationDays(),
            vacation_pay_percentage: this.vacationPayPercentage(),
            adv_days_count: this.advDaysCount(),
            bonus_pay_type: this.bonusPayType(),
            other_surcharges: this.otherSurcharges(),
            pension: this.pension(),
            holiday_planning: this.holidayPlanning(),
            hours_reporting: this.hoursReporting(),
            travel_allowance_fixed_amount: this.travelAllowanceFixedAmount(),
            travel_allowance_per_day: this.travelAllowancePerDay(),
            holiday_bonus_payout: this.holidayBonusPayout(),
            public_holidays: this.publicHolidays().map((holiday) => holiday.toJson()),
        };
    }
    
    async validateModel() {
        const url = '/admin/CompanyOnboarding/ValidateLocationModel';
        
        const body= this.toJson();

        const response = await fetch(url, {
            headers: {
                'Content-type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            this.parent.validationIsSuccessful = false;
            if (response.errors && response.errors.length > 0) {
                this.validationErrors(response.errors);
            }
            
            if (response.data && response.data.length > 0 ) {
                this.validationErrors(response.data);
            }
        }
    }

    async submit() {
        this.saving(true);
        this.parent.submit();
        this.saving(false);
    }
}
